import { render } from "./DialogNewDistitrubutionNumbers.vue?vue&type=template&id=32c30d3a"
import script from "./DialogNewDistitrubutionNumbers.vue?vue&type=script&lang=js"
export * from "./DialogNewDistitrubutionNumbers.vue?vue&type=script&lang=js"

import "./DialogNewDistitrubutionNumbers.vue?vue&type=style&index=0&id=32c30d3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__